import {
  homeContentShellSx,
  providerContentAbovePromoGapSx,
} from '@/features/home/styles/homeStyles'
import { selectBrandBalanceCardSx } from './selectBrandStyles'

export {
  homePageRootSx as rewardsPageRootSx,
  providerShellHeroSx as rewardsHeroSx,
  providerShellHeroShellSx as rewardsHeroShellSx,
  homeHeroGreetingSx as rewardsHeroGreetingSx,
  homeHeroWelcomeSx as rewardsHeroWelcomeSx,
  homeContentInnerSx as rewardsContentInnerSx,
} from '@/features/home/styles/homeStyles'

export {
  selectBrandBalanceAmountSx as rewardsBalanceAmountSx,
  selectBrandBalanceMinSx as rewardsBalanceMinSx,
  selectBrandBalanceIconSx as rewardsBalanceIconSx,
} from './selectBrandStyles'

/** Figma 5131-11444 — Rewards */
export const rewardsHeading = '#0F1729'
export const rewardsSubtitle = '#6B7A90'
export const rewardsTabBorder = '#E4E9F0'
export const rewardsTabInactive = '#6B7A90'
export const rewardsTabActive = '#008CD0'
export const rewardsGiftCardBorder = '#E8EDF2'
export const rewardsGiftPillBg = '#E8F5EF'
export const rewardsGiftPillBorder = '#B6E8D5'
export const rewardsGiftPillText = '#0E8A5F'
export const rewardsGiftMinText = '#008CD0'
export const rewardsGiftDescription = '#0D1B2A'
export const rewardsRedeemShadow = '0px 2px 4px #DCE9FF'
export const rewardsGiftCardShadow = '0px 2px 4px rgba(0, 0, 0, 0.04)'

export const rewardsContentShellSx = {
  ...homeContentShellSx,
  flex: 1,
  pb: 4,
} as const

export const rewardsTitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: { xs: '24px', md: '32px' },
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: rewardsHeading,
  mt: { xs: 3, md: '25px' },
  mb: '8px',
} as const

export const rewardsSubtitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  color: rewardsSubtitle,
  mb: { xs: 3, md: '24px' },
} as const

export const rewardsBalanceCardSx = {
  ...selectBrandBalanceCardSx,
  mb: { xs: 3, md: '46px' },
} as const

export const rewardsTabBarSx = {
  display: 'flex',
  alignItems: 'flex-end',
  borderBottom: `1px solid ${rewardsTabBorder}`,
  minHeight: '41px',
  mb: 0,
  width: '100%',
  overflowX: { xs: 'auto', md: 'visible' },
} as const

export const rewardsTabButtonBaseSx = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  lineHeight: '21px',
  textTransform: 'none',
  minHeight: '40px',
  px: 2,
  py: '9px',
  borderRadius: 0,
  border: 'none',
  bgcolor: 'transparent',
  color: rewardsTabInactive,
  cursor: 'pointer',
  boxSizing: 'border-box',
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.6)',
  },
} as const

export const rewardsTabButtonActiveSx = {
  ...rewardsTabButtonBaseSx,
  fontWeight: 600,
  color: rewardsTabActive,
  bgcolor: '#FFFFFF',
  border: `1.5px solid ${rewardsTabActive}`,
  borderBottom: 'none',
  borderRadius: '8px 8px 0 0',
  mb: '-1px',
  zIndex: 1,
  position: 'relative',
  minWidth: { xs: 'auto', sm: '104px' },
  '&:hover': {
    bgcolor: '#FFFFFF',
  },
} as const

export const rewardsGiftCardSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${rewardsGiftCardBorder}`,
  borderRadius: '0 0 15px 15px',
  boxShadow: rewardsGiftCardShadow,
  p: { xs: 2, md: '24px' },
  minHeight: '187px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  ...providerContentAbovePromoGapSx,
} as const

export const rewardsGiftPillSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  bgcolor: rewardsGiftPillBg,
  border: `1px solid ${rewardsGiftPillBorder}`,
  borderRadius: '20px',
  px: '13px',
  py: '5px',
  height: '31px',
  boxSizing: 'border-box',
} as const

export const rewardsGiftPillTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '18px',
  color: rewardsGiftPillText,
} as const

export const rewardsGiftMinSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '19.5px',
  color: rewardsGiftMinText,
} as const

export const rewardsGiftDescriptionSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '15px',
  lineHeight: '22.5px',
  color: rewardsGiftDescription,
} as const

export const rewardsRedeemButtonSx = {
  width: '160px',
  height: '48px',
  borderRadius: '10px',
  bgcolor: rewardsTabActive,
  textTransform: 'none',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  boxShadow: rewardsRedeemShadow,
  alignSelf: 'flex-start',
  '&:hover': {
    bgcolor: '#007AB8',
  },
  '&.Mui-disabled': {
    bgcolor: '#94A3B8',
    color: '#FFFFFF',
    boxShadow: 'none',
  },
} as const

export const rewardsClaimedWrapSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${rewardsGiftCardBorder}`,
  borderRadius: '0 0 15px 15px',
  boxShadow: rewardsGiftCardShadow,
  p: { xs: 2, md: 3 },
  boxSizing: 'border-box',
  ...providerContentAbovePromoGapSx,
} as const
